import React, { useCallback } from 'react';
import { ReactComponent as BookIcon } from '../../Icons/book.svg';
import { ReactComponent as BookShelfIcon } from '../../Icons/book-shelf.svg';

import './Header.css';

const Header = ({
  activeTab,
  setActiveTab,
  searchQuery,
  setSearchQuery,
  setSelectedCollection = null,
  cookbookCount = null,
  collectionCount = null
}) => {
  const showLibraryStats =
    typeof cookbookCount === 'number' && typeof collectionCount === 'number';

  return (
    <div className="header-container">
      <div className="deck-manager-library-header-toolbar">
        <ul className="nav-list">
          <li className="nav-item">
            <div className="header-nav-icon">
              <BookIcon />
            </div>
            <span
              className={`nav-link ${activeTab === 'cookbooks' ? 'active' : ''}`}
              onClick={useCallback(() => {
                setActiveTab('cookbooks');
                if (setSelectedCollection) {
                  setSelectedCollection(null);
                }
              }, [setActiveTab, setSelectedCollection])}
            >
              Cookbooks
            </span>
          </li>
          <li className="nav-item">
            <div className="header-nav-icon">
              <BookShelfIcon />
            </div>
            <span
              className={`nav-link ${activeTab === 'collections' ? 'active' : ''}`}
              onClick={useCallback(() => {
                setActiveTab('collections');
                if (setSelectedCollection) {
                  setSelectedCollection(null);
                }
              }, [setActiveTab, setSelectedCollection])}
            >
              Collections
            </span>
          </li>
        </ul>
        {showLibraryStats ? (
          <div
            className="deck-manager-library-header-stats"
            aria-label={`${cookbookCount} cookbooks, ${collectionCount} collections`}
          >
            <div className="deck-manager-library-header-stat">
              <span className="deck-manager-library-header-stat__value">{cookbookCount}</span>
              <span className="deck-manager-library-header-stat__label">cookbooks</span>
            </div>
            <div className="deck-manager-library-header-stat">
              <span className="deck-manager-library-header-stat__value">{collectionCount}</span>
              <span className="deck-manager-library-header-stat__label">collections</span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Header;

